import { useEffect } from 'react';

let lockCount = 0;

export const useBodyScrollLock = (isLocked: boolean = true) => {
    useEffect(() => {
        if (!isLocked || typeof window === 'undefined' || typeof document === 'undefined') return;

        lockCount++;
        if (lockCount === 1) {
            try {
                document.body.style.overflow = 'hidden';
            } catch (e) {}
        }

        return () => {
            lockCount = Math.max(0, lockCount - 1);
            if (lockCount === 0) {
                try {
                    document.body.style.overflow = '';
                } catch (e) {}
            }
        };
    }, [isLocked]);
};

export default useBodyScrollLock;
